import { FeedbackMetadataField } from '@modules/feedback/types';
import { getMappedFeedbackSourceMetadataFields } from '@modules/feedback/utils';
import { SourceMetadataViewFragment } from 'generated/graphql';

interface getSortedFeedbackSourceMetadataFieldsParams {
  metadataFields: SourceMetadataViewFragment[] | undefined;
}

export const getSortedFeedbackSourceMetadataFields = ({
  metadataFields,
}: getSortedFeedbackSourceMetadataFieldsParams): FeedbackMetadataField[] => {
  const mappedMetadataFieldsWithValues = getMappedFeedbackSourceMetadataFields({
    metadataFields,
  });

  const sortedMetadataFields = mappedMetadataFieldsWithValues?.sort((a, b) => {
    // isReference=true takes precedence next
    const referenceComparison = Number(b.isReference) - Number(a.isReference);
    if (referenceComparison !== 0) {
      return referenceComparison;
    }

    // isImportant=true takes precedence next
    const importantComparison = Number(b.isImportant) - Number(a.isImportant);
    if (importantComparison !== 0) {
      return importantComparison;
    }

    // alphabetically sort
    return a.key.localeCompare(b.key);
  });

  return sortedMetadataFields;
};
